import { HttpClient, HttpHeaders } from "@angular/common/http";
import { EventEmitter, Injectable, Output } from "@angular/core";
import { environment } from "src/environments/environment";
import * as CryptoJS from 'crypto-js';
import { SharedService } from "../services1/shared.service";
import { ToastrService } from "ngx-toastr";

@Injectable()
export class SingUpService {
    url: any = environment.API_URL;
    lang = sessionStorage.getItem('lang');
    // isSignUp:boolean = false;
    @Output() signUpEvent = new EventEmitter<boolean>();
    header = {};

    constructor(
        private http: HttpClient,
        private sharedService: SharedService,
        private toastService: ToastrService,
    ) { }

    EnableSignUpModel(isEnable){
        if(isEnable == true){
            this.signUpEvent.emit(true);
        }
        else{
            this.signUpEvent.emit(false);
        }
    }

    registerUser(data: any) {
        return this.http.post(this.url + 'user/register', this.sharedService?.newEncryptJson(data));
    } 
    
    registerUserV1(data:any){
        return this.http.post(this.url + 'user/register/v1', this.sharedService?.newEncryptJson(data));
    }

    registerUserLead(data:any){
        return this.http.post(this.url + 'user/register/lead-user', this.sharedService?.newEncryptJson(data));
    }

    login(data:any) {
           
        let postData = this.sharedService?.newEncryptJson(data)
        return this.http.post<any>(this.url + 'user/login', postData);
    }
    
    otpPublicaly(postData){
        return this.http.post<any>(this.url + 'public/send-otp', this.sharedService?.newEncryptJson(postData));
    }

    activeSessions(data:any){
        return this.http.post<any>(this.url+`user/active-sessions`, data);
    }

    logOutAllSessions(data:any){
        return this.http.post<any>(this.url + 'user/logout-all-sessions', data);
    }
    
    logOut(data:any){
        // const headers = new HttpHeaders({
        //     'Content-Type': 'application/x-www-form-urlencoded' // Set content type
        // });
        let token = localStorage.getItem('token');
        if(!token){
            this.clearLocalStorage();
            return;
        }
        return this.http.patch<any>(this.url+'user/logout', data)
            
    }

    clearLocalStorage() {
        localStorage.removeItem('token');
        localStorage.removeItem('currentUser');
        localStorage.removeItem('lang');
        localStorage.removeItem('sortTypeKey');
        localStorage.removeItem('sortTypeOrder');
        localStorage.removeItem('isViewTypeList');
    }

    GetUserByEmail(data:any) {
        return this.http.patch<any>(this.url + 'user/reset-password', data);
    }

    socialLogin(data:any) {
        return this.http.post<any>(this.url + 'auth/social-login', data);
    }
    
    ResendOtp(data:any) {
        return this.http.post<any>(this.url + 'user/resend-otp', data);
    }
    
    updateProfileOtp(data:any) {
        const headers = new HttpHeaders({
            'X-Captcha-Token': 'CustomHeaderValue' // Add your custom header here
          })
        return this.http.post<any>(this.url + 'user/update-profile-otp', data,  { headers });
    }

    UserValidityCheck(data:any) {
        return this.http.post<any>(this.url + 'user/check-valid', data);
    }

    getTermsCondition(data: any) {
        const headers = new HttpHeaders({
            'X-Captcha-Token': 'CustomHeaderValue' // Add your custom header here
          })
        return this.http.post(this.url + 'termscondition/get-terms-condition', data, {headers});
    }

    acceptTermsCondition(data: any) {
        return this.http.post(this.url + 'termscondition/accept-terms-condition', data);
    }

    acceptTermsConditionLatest(data: any) {
        const headers = new HttpHeaders({ 'X-Special-Param': 'delete' });
        return this.http.post(this.url + 'user/accept-terms', data);
    }

    getCaptcha(data: any,) {
        const headers = new HttpHeaders({
            'X-Captcha-Token': 'CustomHeaderValue' // Add your custom header here
          })
        return this.http.get(this.url + 'generateCaptha/generate',  { responseType: 'text', observe:'response'});
    }

    UpdatePassword(data:any) {
        return this.http.patch<any>(this.url + 'user/update-password', data);
    }


    verifyOtp(data:any){
        return this.http.post<any>(this.url + 'user/verify-otp', data);
    }

    resetPasswordVerifyOtp(data:any){
        const headers = new HttpHeaders({ 'X-Special-Param': 'delete' });
        return this.http.post<any>(this.url + 'user/verify-forget-password-otp', data, {headers});
    }

    uploadFile(file: any) {
        const headers = new HttpHeaders({ 'X-Special-Param': 'delete' });
        const fileRetrived = file.get('myFile') as File;
        const response = this.sharedService.fileValidationCheck(fileRetrived);
        if(response.status == false){
            this.toastService.warning(response.message);
        }else{
            return this.http.post(this.url + "upload/file", file, { headers });
        }
    }

}